<template>
  <div class="container-fluid">
    <div class="row">
      <main id="main" class="site-main main-content">
        <article
          id="post-2252"
          class="post-2252 page type-page status-publish hentry"
        >
          <div class="entry-content">
            <div class="hc-contact">
              <div class="container">
                <div class="row tick-cont">
                  <div class="col-md-12 submit-form">
                    <div class="form-title">
                      <h1
                        class="logo"
                        style="margin: 0 auto; text-align: center"
                      >
                        <a
                          href="https://www.clearmeout.com/"
                          style="
                            display: block;
                            width: fit-content;
                            margin: auto;
                          "
                        >
                          <img
                            class="img-responsive"
                            src="/static/assets/images/logo.png"
                            alt="ClearMeOut"
                          />
                        </a>
                      </h1>
                      <h3 style="margin: 10px auto; text-align: center">
                        General Service Request Form
                      </h3>
                      <p style="margin: 10px auto 50px; text-align: center">
                        Submit your information for obtaining the General Service on Personal Content Removal.
                      </p>
                    </div>

                    <form class="wpcf7-form" @submit.prevent="submit">
                      <div class="form-group">
                        <label for="exampleInputEmail1">Who I am*</label>
                        <span
                          class="wpcf7-form-control-wrap select-options"
                          style="display: block; width: 100%"
                          ><select
                            v-model="userType"
                            name="userType"
                            class="wpcf7-form-control wpcf7-select wpcf7-validates-as-required"
                            aria-required="true"
                            aria-invalid="false"
                            required
                            style="background: white; width: 100%"
                          >
                            <option value="MySelf">Myself</option>
                            <option value="Representer">Representer</option>
                            <option value="Guardian">Guardian</option>
                          </select></span
                        >
                      </div>
                      <div class="form-group">
                        <label for="exampleInputEmail1">Full Name*</label>
                        <input
                          type="text"
                          class="form-control"
                          id=""
                          aria-describedby=""
                          placeholder="Enter Full Name"
                          required=""
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputEmail1">Date of Birth*</label>
                        <datetime
                          v-model="dateOfBirth"
                          type="date"
                          input-style="width: 100%;"
                          required=""
                        ></datetime>
                      </div>
                      <div class="form-group">
                        <label for="exampleInputEmail1">Gender*</label>
                        <span
                          class="wpcf7-form-control-wrap select-options"
                          style="display: block; width: 100%"
                          ><select
                            v-model="gender"
                            name="gender"
                            class="wpcf7-form-control wpcf7-select wpcf7-validates-as-required"
                            aria-required="true"
                            aria-invalid="false"
                            required=""
                            style="background: white; width: 100%"
                          >
                            <option value="N/A">N/A</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                          </select></span
                        >
                      </div>
                      <div class="form-group">
                        <label for="exampleInputEmail1">Email address*</label>
                        <input
                          type="email"
                          class="form-control"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                          placeholder="Enter email"
                          required=""
                        />
                        <button
                          type="button"
                          class="btn btn-primary"
                          style="margin: 10px 1px; display: block;border-radius: 10px;background:#6773DD;"
                        >
                          Verify
                        </button>
                      </div>
                      <div class="form-group">
                        <label for="exampleInputEmail1">Mobile Number*</label>
                        <div
                          style="
                            flex: 1 1 0%;
                            flex-direction: row;
                            justify-content: space-between;
                            display: flex;
                            border: 1px solid #c8cccf;
                            border-radius: 10px;
                          "
                        >
                          <vue-country-code
                            @onSelect="onSelect"
                            :preferredCountries="['lk', 'us', 'gb']"
                            style="border: 0"
                          >
                          </vue-country-code>
                          <input
                            class="form-control"
                            id="exampleInputEmail1"
                            aria-describedby="emailHelp"
                            placeholder="Enter mobile number"
                            required=""
                            type="tel"
                            style="max-width: 90%; border: 0"
                          />
                        </div>
                        <button
                          type="button"
                          class="btn btn-primary"
                          style="margin: 10px 1px; display: block;border-radius: 10px;background:#6773DD;"
                        >
                          Verify
                        </button>
                      </div>
                      <div class="form-group">
                        <label for="exampleInputPassword1"
                          >Address Line 1*</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          id="exampleInputAddressLine1"
                          placeholder="Enter Address Line 1"
                          required=""
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputPassword1"
                          >Address Line 2</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          id="exampleInputAddressLine2"
                          placeholder="Enter Address Line 2"
                          required=""
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputPassword1"
                          >State / Province</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          id="exampleInputState"
                          placeholder="Enter State / Province"
                          required=""
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputPassword1"
                          >Postal / Zip Code</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          id="exampleInputPostal"
                          placeholder="Enter Postal / Zip Code"
                          required=""
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputPassword1">City</label>
                        <input
                          type="text"
                          class="form-control"
                          id="exampleInputCity"
                          placeholder="Enter City"
                          required=""
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputPassword1">Country</label>
                        <div
                          style="
                            flex: 1 1 0%;
                            flex-direction: row;
                            justify-content: space-between;
                            display: flex;
                            border: 1px solid #c8cccf;
                            border-radius: 10px;
                          "
                        >
                          <vue-country-code
                            @onSelect="onSelectCountry"
                            :preferredCountries="['lk', 'us', 'gb']"
                            style="border: 0"
                          >
                          </vue-country-code>
                          <input
                            class="form-control"
                            id="exampleInputEmail1"
                            aria-describedby="emailHelp"
                            placeholder="Enter Country"
                            required=""
                            type="text"
                            readonly
                            style="max-width: 90%; border: 0"
                            v-model="country"
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="exampleInputPassword1"
                          >National Identity Card or Passport* 
                          <span class="tooltip" style="display: contents;">
                            <span class="tooltiptext"></span>
                            <span class="fa fa-question-circle"></span>
                          </span>
                          </label
                        >
                        <div v-bind:key="index" v-for="(item, index) in clientInputNIC" style="display: block; margin: 10px 0; position: relative;">
                          <input
                            type="file"
                            class="form-control"
                            v-on:change="onChangeClientInputNICDocs($event, index)"
                            name="inputNIC"
                            id="exampleInputNIC"
                            accept=".jpg,.png"
                            required=""
                          />
                          <button
                            type="button"
                            v-if="(clientInputNIC.length - 1) == index && (clientInputNIC.length) !== clientInputNICLimit"
                            style="position: absolute; top: calc((100% - 25px) / 2); right: -30px; height: 25px;"
                            v-on:click="onAddClientInputNIC"
                          >
                            +
                          </button>
                        </div>
                        <!-- <input
                          type="file"
                          class="form-control"
                          name="exampleInputIDPassportFront"
                          id="exampleInputIDPassportFront"
                          accept=".jpg,.png"
                          required=""
                        />
                        <input
                          type="file"
                          class="form-control"
                          name="exampleInputIDPassportBack"
                          id="exampleInputIDPassportBack"
                          accept=".jpg,.png"
                          required=""
                        /> -->
                      </div>
                      <div class="form-group">
                        <label for="exampleInputPassword1">Billing Proof* <span class="tooltip" style="display: contents;">
                            <span class="tooltiptext"></span>
                            <span class="fa fa-question-circle"></span>
                          </span></label>
                        <div v-bind:key="index" v-for="(item, index) in clientBillinProofInputNIC" style="display: block; margin: 10px 0; position: relative;">
                          <input
                            type="file"
                            class="form-control"
                            v-on:change="onChangeClientBillinProofInputNICDocs($event, index)"
                            name="inputNIC"
                            id="exampleInputNIC"
                            accept=".jpg,.png"
                            required=""
                          />
                          <button
                            type="button"
                            v-if="(clientBillinProofInputNIC.length - 1) == index && (clientBillinProofInputNIC.length) !== clientBillinProofInputNICLimit"
                            style="position: absolute; top: calc((100% - 25px) / 2); right: -30px; height: 25px;"
                            v-on:click="onAddClientBillinProofInputNIC"
                          >
                            +
                          </button>
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="exampleInputPassword1">Supporting Documents* <span class="tooltip" style="display: contents;">
                            <span class="tooltiptext"></span>
                            <span class="fa fa-question-circle"></span>
                          </span></label>
                        <div v-bind:key="index" v-for="(item, index) in clientSupportDocsProofInput" style="display: block; margin: 10px 0; position: relative;">
                          <input
                            type="file"
                            class="form-control"
                            v-on:change="onChangeClientSupportDocsInput($event, index)"
                            name="inputNIC"
                            id="exampleInputNIC"
                            accept=".jpg,.png"
                            required=""
                          />
                          <button
                            type="button"
                            v-if="(clientSupportDocsProofInput.length - 1) == index && (clientSupportDocsProofInput.length) !== clientSupportDocsProofInputLimit"
                            style="position: absolute; top: calc((100% - 25px) / 2); right: -30px; height: 25px;"
                            v-on:click="onAddClientSupportDocsInput"
                          >
                            +
                          </button>
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="exampleInputPassword1">Signature* <span class="tooltip" style="display: contents;">
                            <span class="tooltiptext"></span>
                            <span class="fa fa-question-circle"></span>
                          </span></label>
                        <input
                          type="file"
                          class="form-control"
                          id="exampleInputSignature"
                          accept=".jpg,.png"
                          required=""
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputPassword1">Password*</label>
                        <input
                          v-bind:type="userPasswordType"
                          class="form-control"
                          id="exampleInputPassword1"
                          placeholder="Enter Password"
                          required=""
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputPassword2"
                          >Re-Type Password*</label
                        >
                        <input
                          v-bind:type="userPasswordType"
                          class="form-control"
                          id="exampleInputPassword2"
                          placeholder="Re-Type Password"
                          required=""
                        />
                        <a v-if="!viewUserPassword" href="javascript:void(0)" style="display: block;margin: 10px 0px;" v-on:click="showPassword">Show Password</a>
                        <a v-if="viewUserPassword" href="javascript:void(0)" style="display: block;margin: 10px 0px;" v-on:click="hidePassword">Hide Password</a>
                      </div>
                      <h3 v-if="userType !== 'MySelf'">Client</h3>
                      <div v-if="userType !== 'MySelf'">
                        <div class="form-group">
                          <label for="exampleInputEmail1">Full Name*</label>
                          <input
                            type="text"
                            class="form-control"
                            id=""
                            aria-describedby=""
                            placeholder="Enter Full Name"
                            required=""
                          />
                        </div>
                        <div class="form-group">
                          <label for="exampleInputEmail1">Date of Birth*</label>
                          <datetime
                            v-model="dateOfBirth"
                            type="date"
                            input-style="width: 100%;"
                            required=""
                          ></datetime>
                        </div>
                        <div class="form-group">
                          <label for="exampleInputEmail1">Gender*</label>
                          <span
                            class="wpcf7-form-control-wrap select-options"
                            style="display: block; width: 100%"
                            ><select
                              v-model="gender"
                              name="gender"
                              class="wpcf7-form-control wpcf7-select wpcf7-validates-as-required"
                              aria-required="true"
                              aria-invalid="false"
                              required=""
                              style="background: white; width: 100%"
                            >
                              <option value="N/A">N/A</option>
                              <option value="Male">Male</option>
                              <option value="Female">Female</option>
                            </select></span
                          >
                        </div>
                        <div
                          class="form-group"
                          v-if="userType == 'Representer'"
                        >
                          <label for="exampleInputEmail1">Email address*</label>
                          <input
                            type="email"
                            class="form-control"
                            id="exampleInputEmail1"
                            aria-describedby="emailHelp"
                            placeholder="Enter email"
                            required=""
                          />
                          <button
                            type="button"
                            class="btn btn-primary"
                            style="margin: 10px 1px; display: block;border-radius: 10px;background:#6773DD;"
                          >
                            Verify
                          </button>
                        </div>
                        <div
                          class="form-group"
                          v-if="userType == 'Representer'"
                        >
                          <label for="exampleInputEmail1">Mobile Number*</label>
                          <div
                            style="
                              flex: 1 1 0%;
                              flex-direction: row;
                              justify-content: space-between;
                              display: flex;
                              border: 1px solid #c8cccf;
                              border-radius: 10px;
                            "
                          >
                            <vue-country-code
                              @onSelect="onSelect"
                              :preferredCountries="['lk', 'us', 'gb']"
                              style="border: 0"
                            >
                            </vue-country-code>
                            <input
                              class="form-control"
                              id="exampleInputEmail1"
                              aria-describedby="emailHelp"
                              placeholder="Enter mobile number"
                              required=""
                              type="tel"
                              style="max-width: 90%; border: 0"
                            />
                          </div>
                          <button
                            type="button"
                            class="btn btn-primary"
                            style="margin: 10px 1px; display: block;border-radius: 10px;background:#6773DD;"
                          >
                            Verify
                          </button>
                        </div>
                        <div class="form-group">
                          <label for="exampleInputClientAddressLine"
                            >Address Line 1*</label
                          >
                          <input
                            type="text"
                            class="form-control"
                            id="exampleInputClientAddressLine"
                            placeholder="Enter Address Line 1"
                            required=""
                          />
                        </div>
                        <div class="form-group">
                          <label for="exampleInputClientAddressLine2"
                            >Address Line 2</label
                          >
                          <input
                            type="text"
                            class="form-control"
                            id="exampleInputClientAddressLine2"
                            placeholder="Enter Address Line 2"
                            required=""
                          />
                        </div>
                        <div class="form-group">
                          <label for="exampleInputClientAddressState"
                            >State / Province</label
                          >
                          <input
                            type="text"
                            class="form-control"
                            id="exampleInputState"
                            placeholder="Enter State / Province"
                            required=""
                          />
                        </div>
                        <div class="form-group">
                          <label for="exampleInputClientAddressPostal"
                            >Postal / Zip Code</label
                          >
                          <input
                            type="text"
                            class="form-control"
                            id="exampleInputClientAddressPostal"
                            placeholder="Enter Postal / Zip Code"
                            required=""
                          />
                        </div>
                        <div class="form-group">
                          <label for="exampleInputClientAddresCity">City</label>
                          <input
                            type="text"
                            class="form-control"
                            id="exampleInputClientAddresCity"
                            placeholder="Enter City"
                            required=""
                          />
                        </div>
                        <div class="form-group">
                          <label for="exampleInputClientAddresCountry"
                            >Country</label
                          >
                          <div
                            style="
                              flex: 1 1 0%;
                              flex-direction: row;
                              justify-content: space-between;
                              display: flex;
                              border: 1px solid #c8cccf;
                              border-radius: 10px;
                            "
                          >
                            <vue-country-code
                              @onSelect="onSelectCountry"
                              :preferredCountries="['lk', 'us', 'gb']"
                              style="border: 0"
                            >
                            </vue-country-code>
                            <input
                              class="form-control"
                              id="exampleInputClientAddresCountry"
                              aria-describedby="emailHelp"
                              placeholder="Enter Country"
                              required=""
                              type="text"
                              readonly
                              style="max-width: 90%; border: 0"
                              v-model="country"
                            />
                          </div>
                        </div>
                        <div
                          class="form-group"
                          v-if="userType == 'Representer'"
                        >
                          <label for="exampleInputNIC"
                            >National Identity Card or Passport* <span class="tooltip" style="display: contents;">
                            <span class="tooltiptext"></span>
                            <span class="fa fa-question-circle"></span>
                          </span></label
                          >
                          <div v-bind:key="index" v-for="(item, index) in clientRepresenterInputNIC" style="display: block; margin: 10px 0; position: relative;">
                            <input
                              type="file"
                              class="form-control"
                              v-on:change="onChangeClientRepresenterInputNICDocs($event, index)"
                              name="inputNIC"
                              id="exampleInputNIC"
                              accept=".jpg,.png"
                              required=""
                            />
                            <button
                              type="button"
                              v-if="(clientRepresenterInputNIC.length - 1) == index && (clientRepresenterInputNIC.length) !== clientRepresenterInputNICLimit"
                              style="position: absolute; top: calc((100% - 25px) / 2); right: -30px; height: 25px;"
                              v-on:click="onAddClientRepresenterInputNIC"
                            >
                              +
                            </button>
                          </div>
                          <!-- <input
                            type="file"
                            class="form-control"
                            name="exampleInputNICFront"
                            id="exampleInputNIC"
                            accept=".jpg,.png"
                            required=""
                          />
                          <input
                            type="file"
                            class="form-control"
                            name="exampleInputNIC"
                            id="exampleInputNICBack"
                            accept=".jpg,.png"
                            required=""
                          /> -->
                        </div>
                        <div class="form-group" v-if="userType == 'Guardian'">
                          <label for="exampleInputBirthCert"
                            >Birth Certificate* <span class="tooltip" style="display: contents;">
                            <span class="tooltiptext"></span>
                            <span class="fa fa-question-circle"></span>
                          </span></label
                          >
                          <input
                            type="file"
                            class="form-control"
                            id="exampleInputBirthCert"
                            accept=".jpg,.png"
                            required=""
                          />
                        </div>
                        <div class="form-group">
                          <label for="exampleInputPassword1">Billing Proof* <span class="tooltip" style="display: contents;">
                              <span class="tooltiptext"></span>
                              <span class="fa fa-question-circle"></span>
                            </span></label>
                          <div v-bind:key="index" v-for="(item, index) in clientClientBillinProofInputNIC" style="display: block; margin: 10px 0; position: relative;">
                            <input
                              type="file"
                              class="form-control"
                              v-on:change="onChangeClientBillinProofInputNICDocs($event, index)"
                              name="inputNIC"
                              id="exampleInputNIC"
                              accept=".jpg,.png"
                              required=""
                            />
                            <button
                              type="button"
                              v-if="(clientClientBillinProofInputNIC.length - 1) == index && (clientClientBillinProofInputNIC.length) !== clientClientBillinProofInputNICLimit"
                              style="position: absolute; top: calc((100% - 25px) / 2); right: -30px; height: 25px;"
                              v-on:click="onAddClientClientBillinProofInputNIC"
                            >
                              +
                            </button>
                          </div>
                        </div>
                        <div
                          class="form-group"
                          v-if="userType == 'Representer'"
                          style="position: relative;"
                        >
                          <label for="exampleInputLegal"
                            >Supporting Documents* <span class="tooltip" style="display: contents;">
                            <span class="tooltiptext"></span>
                            <span class="fa fa-question-circle"></span>
                          </span></label
                          >
                          <div v-bind:key="index" v-for="(item, index) in clientInputLegalDocs" style="display: block; margin: 10px 0; position: relative;">
                            <input
                              type="file"
                              class="form-control"
                              v-on:change="onChangeClientInputLegalDocs($event, index)"
                              name="inputLegal"
                              id="exampleInputLegal"
                              accept=".jpg,.png"
                              required=""
                            />
                            <button
                              type="button"
                              v-if="(clientInputLegalDocs.length - 1) == index && (clientInputLegalDocs.length) !== clientInputLegalDocsLimit"
                              style="position: absolute; top: calc((100% - 25px) / 2); right: -30px; height: 25px;"
                              v-on:click="onAddClientInputLegalDocs"
                            >
                              +
                            </button>
                          </div>
                        </div>               
                        <div
                          class="form-group"
                          v-if="userType == 'Representer'"
                        >
                          <label for="exampleInputSignature">Signature* <span class="tooltip" style="display: contents;">
                            <span class="tooltiptext"></span>
                            <span class="fa fa-question-circle"></span>
                          </span></label>
                          <div v-bind:key="index" v-for="(item, index) in clientInputSignature" style="display: block; margin: 10px 0; position: relative;">
                            <input
                              type="file"
                              class="form-control"
                              v-on:change="onChangeClientInputSignatureDocs($event, index)"
                              name="inputSignature"
                              id="exampleInputSignature"
                              accept=".jpg,.png"
                              required=""
                            />
                            <button
                              type="button"
                              v-if="(clientInputSignature.length - 1) == index && (clientInputSignature.length) !== clientInputSignatureLimit"
                              style="position: absolute; top: calc((100% - 25px) / 2); right: -30px; height: 25px;"
                              v-on:click="onAddClientInputSignature"
                            >
                              +
                            </button>
                          </div>
                        </div>
                        
                        <div class="form-group" v-if="userType == 'Guardian'">
                          <label for="exampleInputLegalDocs"
                            >Supporting Documents* <span class="tooltip" style="display: contents;">
                            <span class="tooltiptext"></span>
                            <span class="fa fa-question-circle"></span>
                          </span></label
                          >
                          <div v-bind:key="index" v-for="(item, index) in clientInputSupportDocs" style="display: block; margin: 10px 0; position: relative;">
                            <input
                              type="file"
                              class="form-control"
                              v-on:change="onChangeClientInputSignatureDocs($event, index)"
                              name="inputSignature"
                              id="exampleInputSignature"
                              accept=".jpg,.png"
                              required=""
                            />
                            <button
                              type="button"
                              v-if="(clientInputSupportDocs.length - 1) == index && (clientInputSupportDocs.length) !== clientInputSupportDocsLimit"
                              style="position: absolute; top: calc((100% - 25px) / 2); right: -30px; height: 25px;"
                              v-on:click="onAddClientInputSupportDocs"
                            >
                              +
                            </button>
                          </div>
                        </div>
                      </div>
                      <button type="button" class="btn btn-primary check-btn" v-on:click="goNext" style="border-radius: 10px;background:#6773DD;margin:0 auto;display: block;">
                        Next
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            <div class="clearfix"></div>
          </div>
          <!-- .entry-content -->
        </article>
      </main>
    </div>
  </div>
</template>

<script>
import { Datetime } from "vue-datetime";

export default {
  name: "support_track",
  data() {
    return {
      msg: "Clear Me Out - Support",
      userType: "MySelf",
      ticketNumber: "",
      emailRequiredError: false,
      ticketNumberRequiredError: false,
      emailError: false,
      dateOfBirth: new Date(),
      country: "Sri Lanka",
      clientInputLegalDocsLimit: 10,
      clientInputSignatureLimit: 1,
      clientInputNICLimit: 2,
      clientBillinProofInputNICLimit: 10,
      clientSupportDocsProofInputLimit: 2,
      clientClientBillinProofInputNICLimit: 2,
      clientRepresenterInputNICLimit: 2,
      clientInputSupportDocsLimit: 2,
      gender: "",
      clientInputLegalDocs: [{file: ""}],
      clientInputSignature: [{file: ""}],
      clientBillinProofInputNIC: [{file: ""}],
      clientSupportDocsProofInput: [{file: ""}],
      clientClientBillinProofInputNIC: [{file: ""}],
      clientInputSupportDocs: [{file: ""}],
      clientInputNIC: [{file: ""}],
      clientRepresenterInputNIC: [{file: ""}],
      viewUserPassword: false,
      userPasswordType: "password",
    };
  },
  components: {
    datetime: Datetime,
  },
  methods: {
    showPassword: function() {
      this.viewUserPassword = true;
      this.userPasswordType = "text";
    },
    hidePassword: function() {
      this.viewUserPassword = false;
      this.userPasswordType = "password";
    },
    onSelect: function (d) {
      console.log("e", d);
    },
    goNext: function (d) {
      this.$router.push("select-package");
    },
    onAddClientInputLegalDocs: function (d) {
      if(this.clientInputLegalDocs.length > this.clientInputLegalDocsLimit) {
        return;
      }
      this.clientInputLegalDocs.push({file: ""});
    },
    onAddClientClientBillinProofInputNIC: function (d) {
      if(this.clientClientBillinProofInputNIC.length > this.clientClientBillinProofInputNICLimit) {
        return;
      }
      this.clientClientBillinProofInputNIC.push({file: ""});
    },
    onAddClientInputSignature: function (d) {
      if(this.clientInputSignature.length > this.clientInputSignatureLimit) {
        return;
      }
      this.clientInputSignature.push({file: ""});
    },
    onAddClientInputNIC: function (d) {
      if(this.clientInputNIC.length > this.clientInputNICLimit) {
        return;
      }
      this.clientInputNIC.push({file: ""});
    },
    onAddClientInputSupportDocs: function (d) {
      if(this.clientInputSupportDocs.length > this.clientInputSupportDocsLimit) {
        return;
      }
      this.clientInputSupportDocs.push({file: ""});
    },
    onAddClientBillinProofInputNIC: function (d) {
      if(this.clientBillinProofInputNIC.length > this.clientBillinProofInputNICLimit) {
        return;
      }
      this.clientBillinProofInputNIC.push({file: ""});
    },
    onAddClientSupportDocsInput: function (d) {
      if(this.clientSupportDocsProofInput.length > this.clientSupportDocsProofInputLimit) {
        return;
      }
      this.clientSupportDocsProofInput.push({file: ""});
    },
    onAddClientClientBillinProofInputNIC: function (d) {
      if(this.clientClientBillinProofInputNIC.length > this.clientClientBillinProofInputNICLimit) {
        return;
      }
      this.clientClientBillinProofInputNIC.push({file: ""});
    },
    onAddClientRepresenterInputNIC: function (d) {
      if(this.clientRepresenterInputNIC.length > this.clientRepresenterInputNICLimit) {
        return;
      }
      this.clientRepresenterInputNIC.push({file: ""});
    },
    onChangeClientInputLegalDocs: function (item, index) {
      if(item && item.target && item.target.files && Array.isArray(item.target.files)) {
        this.clientInputLegalDocs[index].file = item.target.files[0];
      } else {
        this.clientInputLegalDocs[index].file = null;
      }
    },
    onChangeClientInputSignatureDocs: function (item, index) {
      if(item && item.target && item.target.files && Array.isArray(item.target.files)) {
        this.clientInputSignature[index].file = item.target.files[0];
      } else {
        this.clientInputSignature[index].file = null;
      }
    },
    onSelectCountry: function (d) {
      console.log("onSelectCountry:e", d);
      this.country = d.name;
    },
    submit: function (e) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      const $this = this;
      this.emailRequiredError = false;
      this.ticketNumberRequiredError = false;
      this.emailError = false;

      jQuery
        .post("http://stagingportal.clearmeout.com/signup.php")
        .done(function (data) {
          console.log("data", data);
          $this.email = "";
          $this.ticketNumber = "";
          if (data.status == 500) {
            $this.$toast.open({
              message: data.status_message,
              type: "error",
            });
          }
        })
        .fail(function (data) {
          console.log("data", data);
          $this.$toast.open({
            message:
              "Invalid registration details. Please update and submit again.",
            type: "error",
          });
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.video-container {
  display: block;
  min-height: 40vw;
}
.bg-1,
.bg-2 {
  display: block;
  width: 100%;
  height: calc(40vw / 2);
}

.bg-1 {
  background: #fff;
}

.bg-2 {
  background: #6b67e4;
}
.vimeo-container {
  position: relative;
  min-height: 500px;
  overflow: hidden;
  padding: 0;
}
.vimeo-wrapper-test {
  display: block;
  position: absolute;
  top: 0%;
  left: calc((100vw - 50vw) / 2);
  margin: 0 auto;
  width: calc(50vw);
  height: 100%;
}
.vimeo-wrapper-test iframe {
  width: 100%;
  height: 100%; /* Given a 16:9 aspect ratio, 9/16*100 = 56.25 */
  min-height: 100%;
  /* min-width: 177.77vh; Given a 16:9 aspect ratio, 16/9*100 = 177.77 */
  position: relative;
  top: 0%;
  left: 0%;
  /* transform: translate(-50%, -50%); */
}

.tooltip {
  position: relative;
  /* display: inline-block; */
  border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 10px;
  font-size: 0.8em;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  bottom: 100%;
  left: 0;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/register.vue